import { Flex, getDisplayDate, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { BillDescription } from '@views/bills/routes/BillsList/legacy/elements/BillDescription'
import { getBillAmountToDisplayValue } from '@views/bills/utils/getBillAmountToDisplayValue'

import { getCurrentLocale } from '../../../../../../../../utils'
import { BillType } from '../../../../../../../bills/enums/billType'
import { usePaymentModal } from '../../../../../../../paymentReconciliationModal/contexts'
import { PayableSubject } from '../../../../../../../paymentReconciliationModal/types'
import * as Styled from './styles'

interface SubjectsListItemContentProps {
  subject: PayableSubject
}

export const SubjectsListItemContent = ({ subject }: SubjectsListItemContentProps): ReactElement => {
  const { balance, entryDate, lineDescription, type } = subject
  const subjectNumber = 'voucherNo' in subject ? subject.voucherNo : subject.invoiceNo
  const { subjectCurrencyId } = usePaymentModal()

  const locale = getCurrentLocale()
  const shouldShowAmount = !!balance && !!subjectCurrencyId
  const isCreditNote = type === BillType.CreditNote

  return (
    <Styled.SubjectsListItemContentWrapper>
      <Flex justifyContent="space-between">
        <Styled.DetailsWrapper>
          <Text colorVariant="secondary">{entryDate ? getDisplayDate(new Date(entryDate), locale) : '-'}</Text>
          <Text colorVariant="secondary">#{subjectNumber}</Text>
          <BillDescription isCreditNote={isCreditNote}>{lineDescription}</BillDescription>
        </Styled.DetailsWrapper>
        {shouldShowAmount && (
          <Text>{getBillAmountToDisplayValue({ amount: balance, currency: subjectCurrencyId, isCreditNote })}</Text>
        )}
      </Flex>
    </Styled.SubjectsListItemContentWrapper>
  )
}
